// T-047 · Which household member's account is each side of a movement?
//
// Both legs of a logged movement used to be forced onto the ONE member picked
// under "For which family member", so logging "Taekus Business → Coinbase"
// for Soha created a brand-new, never-set "Soha's Taekus Business" and
// debited THAT — Beko's real TK-Biz (the account the $500 actually left)
// never moved, while Soha's Coinbase still gained the $500. A household
// shares accounts across its members all the time (one TK-Biz funds every
// sub-account's Coinbase), so each side gets its own owner, defaulted to the
// account that is real:
//   1. the picked member's own account of that kind, if it is real
//      (balance set, or any live movement through it);
//   2. else the single household member who does have a real one;
//   3. else the picked member (a fresh account is created on submit).
// A never-used auto-created placeholder never wins the default.
//
// `accounts` is useInvestmentData's data.accounts: every active household
// account with { id, memberId, accountKind, isSet, balance, movementCount,
// hasHistory }. Pure functions so tests/investment-v2 can exercise them
// without a bundler.

export function defaultOwnerFor(kind, whoId, accounts) {
  if (!kind || !whoId) return whoId || '';
  const real = (accounts || []).filter((a) => a.accountKind === kind && a.hasHistory);
  if (real.some((a) => a.memberId === whoId)) return whoId;
  const owners = [...new Set(real.map((a) => a.memberId))];
  if (owners.length === 1) return owners[0];
  return whoId;
}

const fmtSigned$ = (n) => (n < 0 ? '-$' : '$') + Math.round(Math.abs(n)).toLocaleString('en-US');

// "Beko (you)'s Taekus Business · $5,000 balance" — enough for the investor
// to see which row is the real account before they log against it.
export function ownerOptionLabel(m, kind, kindLabel, accounts) {
  const a = (accounts || []).find((x) => x.memberId === m.id && x.accountKind === kind);
  const name = m.role === 'holder' ? `${m.name} (you)` : m.name;
  let tail;
  if (!a) tail = 'new account';
  else if (a.isSet && a.balance != null) tail = `${fmtSigned$(a.balance)} balance`;
  else if (a.movementCount > 0) tail = `${a.movementCount} movement${a.movementCount === 1 ? '' : 's'}, balance not set`;
  else tail = 'never used';
  return `${name}'s ${kindLabel || kind} · ${tail}`;
}
